import { AppThunk } from "../../app/store";
import { authSlice } from "./slice";
const { actions } = authSlice;

export const setToken =
  (token: string): AppThunk =>
  dispatch => {
    dispatch(actions.setToken(token));
  };
